<template>
  <div>
    <div class="form-group">
      <label for="start_date" class="col-md-2 control-label">Start date</label>
      <div class="col-md-8">
        <datepicker
          id="start_date_input"
          name="start_date_input"
          :format="customFormatter"
          :language="languages.en"
          :full-month-name="false"
          :monday-first="true"
          :clear-button="true"
          :highlighted="highlighted"
          placeholder="From the big bang"
          :disabledDates="startDisabledDates"
          v-on:selected="checkEndDate"
          :key="startKey"
          :value="startValue"

        ></datepicker>
      </div>
    </div>

    <div class="form-group">
      <label for="end_date" class="col-md-2 control-label">End date</label>
      <div class="col-md-8">
        <div class="input-append date" id="end_date" name="end_date">
          <datepicker
            id="end_date_input"
            name="end_date_input"
            :format="customFormatter"
            :language="languages.en"
            :full-month-name="false"
            :monday-first="true"
            :clear-button="true"
            :highlighted="highlighted"
            placeholder="To the big crunch"
            :disabledDates="endDisabledDates"
            v-on:selected="checkStartDate"
            :key="endKey"
            :value="endValue"

          ></datepicker>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import * as lang from "vuejs-datepicker/src/locale";
import moment from "moment";

const state = {
  currentDate: new Date(),
};

export default {
  name: "app",

  components: {
    Datepicker,
  },

  data() {
    return {
      startKey: 0,
      endKey: 0,
      openDate: state.currentDate,
      startDisabledDates: {},
      endDisabledDates: {},
      highlighted: {
        dates: [state.currentDate],
      },
      eventMsg: null,
      state: state,
      language: "en",
      languages: lang,
      vStartDate: null,
      vEndDate: null,
      changedMonthLog: [],
      startValue: null,
      endValue: null,
    };
  },

  methods: {
    customFormatter(date) {
      return moment(date).format("YYYY-MM-DD");
    },

    checkEndDate(val) {

      this.startValue = val;

      if (this.endValue === null || this.startValue === null) {
      } else {
        if (val > this.endValue) {
          this.endValue = val;
          //this.endKey += 1;
        }
      }
    },

    checkStartDate(val) {

      this.endValue = val;

      if (this.startValue === null || this.endValue === null) {
      } else {
        if (val < this.startValue) {
          this.startValue = val;
          //this.startKey += 1;
        }
      }
    },
  },
};
</script>
